import { Table } from "react-bootstrap";
import jalaliTime from "../../../functions/jalaliTime";
import Laoder from "../../../components/loading/Loader";
import PrintLink from "../../../components/shipment/Factor/PrintLink";

function CreditTable({ data, credit, page, items, isFetching }) {
  return (
    <section>
      <div className="d-flex flex-wrap justify-content-center align-items-center mb-4">
        <span style={{ fontSize: 14 }}>اعتباری سرپرستی:</span>
        <span className="me-2 fs-2 text-primary">
          {credit.toLocaleString()}
        </span>
        <span className="me-2" style={{ fontSize: 14 }}>
          (ریال)
        </span>
      </div>

      <div className="w-100 overflow-x-auto px-1">
        <Table bordered striped className="align-middle text-center">
          <thead>
            <tr>
              <th>ردیف</th>
              <th>شماره سفارش</th>
              <th>واریز / برداشت</th>
              <th>مبلغ</th>
              <th>اعتبار</th>
              <th>توضیحات</th>
              <th>کد رهگیری</th>
              <th>تاریخ</th>
            </tr>
          </thead>
          <tbody>
            {isFetching && (
              <tr>
                <td colSpan="8">
                  <Laoder />
                </td>
              </tr>
            )}
            {isFetching === false &&
              data.map((item, idx) => (
                <tr key={item.id}>
                  <td>{idx + 1 + (page - 1) * items}</td>
                  <td>
                    <PrintLink ids={[item.totalPostId]}>
                      {item.numberParcel}
                    </PrintLink>
                  </td>
                  <td>{item.isDeposit ? "واریز" : "برداشت"}</td>
                  <td>{item.amount.toLocaleString()}</td>
                  <td>{item.credit.toLocaleString()}</td>
                  <td>{item.description}</td>
                  <td>{item.trackingCode}</td>
                  <td>{jalaliTime(item.created_at).full}</td>
                </tr>
              ))}
          </tbody>
        </Table>
      </div>
    </section>
  );
}

export default CreditTable;
